import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { DistributionBlockTypeApiEnum } from '../../../api/distributions/enum/distribution-block-type-api.enum';

export enum DistributionBlockTypeEnum {
    title = 'TITLE',
    text = 'TEXT',
    image = 'IMAGE',
    divider = 'DIVIDER',
    button = 'BUTTON',
    code = 'CODE',
    footer = 'FOOTER',
    link = 'LINK',
    oneColumnLayout = 'ONE_COLUMN_LAYOUT',
    twoColumnLayout = 'TWO_COLUMN_LAYOUT',
    threeColumnLayout = 'THREE_COLUMN_LAYOUT'
}

export const distributionBlockTypeEnumToDistributionBlockTypeApiEnum: Map<DistributionBlockTypeEnum, DistributionBlockTypeApiEnum> = new Map([
    [DistributionBlockTypeEnum.title, DistributionBlockTypeApiEnum.title],
    [DistributionBlockTypeEnum.text, DistributionBlockTypeApiEnum.text],
    [DistributionBlockTypeEnum.image, DistributionBlockTypeApiEnum.image],
    [DistributionBlockTypeEnum.divider, DistributionBlockTypeApiEnum.divider],
    [DistributionBlockTypeEnum.button, DistributionBlockTypeApiEnum.button],
    [DistributionBlockTypeEnum.code, DistributionBlockTypeApiEnum.code],
    [DistributionBlockTypeEnum.footer, DistributionBlockTypeApiEnum.footer],
    [DistributionBlockTypeEnum.link, DistributionBlockTypeApiEnum.link],
    [DistributionBlockTypeEnum.oneColumnLayout, DistributionBlockTypeApiEnum.oneColumnLayout],
    [DistributionBlockTypeEnum.twoColumnLayout, DistributionBlockTypeApiEnum.twoColumnLayout],
    [DistributionBlockTypeEnum.threeColumnLayout, DistributionBlockTypeApiEnum.threeColumnLayout]
]);

export const distributionBlockTypeApiEnumToDistributionBlockTypeEnum: Map<DistributionBlockTypeApiEnum, DistributionBlockTypeEnum> = new Map([
    [DistributionBlockTypeApiEnum.title, DistributionBlockTypeEnum.title],
    [DistributionBlockTypeApiEnum.text, DistributionBlockTypeEnum.text],
    [DistributionBlockTypeApiEnum.image, DistributionBlockTypeEnum.image],
    [DistributionBlockTypeApiEnum.divider, DistributionBlockTypeEnum.divider],
    [DistributionBlockTypeApiEnum.button, DistributionBlockTypeEnum.button],
    [DistributionBlockTypeApiEnum.code, DistributionBlockTypeEnum.code],
    [DistributionBlockTypeApiEnum.footer, DistributionBlockTypeEnum.footer],
    [DistributionBlockTypeApiEnum.link, DistributionBlockTypeEnum.link],
    [DistributionBlockTypeApiEnum.oneColumnLayout, DistributionBlockTypeEnum.oneColumnLayout],
    [DistributionBlockTypeApiEnum.twoColumnLayout, DistributionBlockTypeEnum.twoColumnLayout],
    [DistributionBlockTypeApiEnum.threeColumnLayout, DistributionBlockTypeEnum.threeColumnLayout]
]);

export const styleTypeApiEnumToDistributionBlockTypeEnum = new Map<StyleTypesApiEnum, DistributionBlockTypeEnum>([
    [StyleTypesApiEnum.TITLE, DistributionBlockTypeEnum.title],
    [StyleTypesApiEnum.TEXT, DistributionBlockTypeEnum.text],
    [StyleTypesApiEnum.IMAGE, DistributionBlockTypeEnum.image],
    [StyleTypesApiEnum.BUTTON, DistributionBlockTypeEnum.button],
    [StyleTypesApiEnum.DIVIDER, DistributionBlockTypeEnum.divider],
    [StyleTypesApiEnum.FOOTER, DistributionBlockTypeEnum.footer],
    [StyleTypesApiEnum.LINK, DistributionBlockTypeEnum.link],
    [StyleTypesApiEnum.ONE_COLUMN_LAYOUT, DistributionBlockTypeEnum.oneColumnLayout],
    [StyleTypesApiEnum.TWO_COLUMN_LAYOUT, DistributionBlockTypeEnum.twoColumnLayout],
    [StyleTypesApiEnum.THREE_COLUMN_LAYOUT, DistributionBlockTypeEnum.threeColumnLayout]
]);

